export default "/images/afc6a9b57e58502d75d935d43657d09b.jpg";